import routerOptions0 from "/home/runner/work/hokify/hokify/node_modules/.pnpm/nuxt@3.17.6_@types+node@20.19.0_eslint@8.57.1_sass@1.44.0_tsx@4.20.3_typescript@5.9.3/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/hokify/hokify/apps/international-page-app/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}